const onResize = () => {
    requestAnimationFrame(() => {
        const doc = document.documentElement
        const height = window?.visualViewport?.height ?? window.innerHeight

        doc.style.setProperty('--full-height', `${height}px`)

        const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        if (doc.getAttribute('data-header-height') !== headerHeight) {
            doc.setAttribute('data-header-height', headerHeight)
        }

        const width = String(window?.visualViewport?.width ?? window.innerWidth)
        if (doc.getAttribute('data-width') !== width) {
            doc.setAttribute('data-width', width)
        }
    })
}

window.addEventListener('resize', onResize, {passive: true})
requestAnimationFrame(() => {
    onResize()
})
